import styled from 'styled-components';

export const SubsystemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubsystemCoverageWrapper = styled.div`

`;
